import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/CSS/Variable.css";
import "../src/CSS/textHederSection.css";
import "./index.css";
import "./Components/common/header.css";
import "../src/Pages/Auth/Form.css";
import "../src/CSS/Loding.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Pages/context/AuthProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);
